import { InsiderBuyingInfo } from "../services/insider-buying-info";

export const getBuyingInfoRows = ({ data }: { data?: InsiderBuyingInfo }) => {
  const info = data?.data ?? [];
  return info.map((data, i) => ({
    id: i,
    filingAt: data.filingAt ?? "-",
    buyerName: data.buyerName ?? "-",
    buyerTitle: data.buyerTitle ?? "-",
    tradeAt: data.tradeAt ?? "-",
    tradeCash: data.tradeCash ?? "-",
    tradeNum: data.tradeNum ?? "-",
    tradeNumAfter: data.tradeNumAfter ?? "-",
    stockCategory: data.stockCategory ?? "-",
  }));
};
